import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { TransportOptionsComponent } from './transport-options.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from 'src/tmc-yard/components/transport-options-panel/transport-options-panel.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    TransportOptionsPanelModule
  ],
  declarations: [
    TransportOptionsComponent
  ]
})
export class TransportOptionDetailsModule { }
